import axios from '@utils/http'

export const state = {
  facilityCodingMetrics: {},
}

export const getters = {}

export const mutations = {}

export const actions = {
  codingMetrics({ commit, dispatch, getters }, { facilityId }) {
    if (facilityId && state.facilityCodingMetrics[facilityId]) {
      return new Promise(resolve => {
        resolve(state.facilityCodingMetrics[facilityId])
      })
    }
    return axios.get(`/api/dashboard/codingMetrics`).then(response => {
      if (facilityId) {
        state.facilityCodingMetrics[facilityId] = response.data
      }

      return response.data
    })
  },
  requestCreatedChartData({ commit, dispatch, getters }) {
    return axios
      .get(`/api/dashboard/requestCreatedChartData`)
      .then(response => {
        return response.data
      })
  },
  pendingRequestCounts({ commit, dispatch, getters }) {
    return axios.get(`/api/dashboard/pendingRequestCounts`).then(response => {
      return response.data
    })
  },
}
